import { Component, input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  RdsCardModule,
  RdsIconsModule,
  RdsButtonModule,
  RdsLinkModule,
} from '@rds/angular-components';
import { DynamicModule } from 'ng-dynamic-component';
import { OfferingCommunity } from '../../../models/offering';
import { BUTTON_TEXTS } from '../../../constants/buttons.constants';

@Component({
  selector: 'inexp-offering-communities',
  imports: [
    RdsCardModule,
    RdsIconsModule,
    RdsButtonModule,
    DynamicModule,
    RdsLinkModule,
    RouterModule,
  ],
  templateUrl: './offering-communities.component.html',
  styleUrl: './offering-communities.component.scss',
})
export class OfferingCommunitiesComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<any>();
  communities = input<OfferingCommunity[]>();

  BUTTONS = BUTTON_TEXTS;
}
